import React from "react";
import { Form, Icon, Input, Checkbox, Radio, Select } from "antd";

import PatientElectronicText from "./Texts/PatientElectronicText";
import SurrogateElectronicText from "./Texts/SurrogateElectronicText";
import Signature from "./Signature";
import SignatureTrimmed from "./SignatureTrimmed";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    const showForEmail = !(props.consentMethodType === "Email" && !props.token);
    const isEmail = props.consentMethodType === "Email";
    const isPatient = props.consentPersonType === "Patient";
    const isSurrogate = props.consentPersonType === "Surrogate";
    const hasLanguage = props.form.getFieldValue('sb_dic_interpreter_language') !== undefined && props.form.getFieldValue('sb_dic_interpreter_language').length > 0;

    return (
      <div className="form-group">
        <h4>
          {props.consentPersonType === "Surrogate"
            ? "Consent Process - Surrogate"
            : "Consent Process - Patient"}
        </h4>

        <div className="form-group-details">
          {props.siteID && (
            <h5>
              Site ID: <b>{props.siteID}</b>
            </h5>
          )}
          {props.userID && (
            <h5>
              User ID: <b>{props.userID}</b>
            </h5>
          )}
          <h5>
            Subject ID: <b>{props.subjectID}</b>
          </h5>
        </div>

        {props.consentPersonType === "Surrogate" ? (
          <SurrogateElectronicText {...props} />
        ) : (
          <PatientElectronicText {...props} />
        )}

        <p>
          <strong>Server Date (UTC): {props.date || props.consentDate}</strong>
        </p>
        <p>
          <strong>Consent Type: {props.consentPersonType}</strong>
        </p>
        <p>
          <strong>Consent Method: {props.consentMethodType}</strong>
        </p>
        <p>&nbsp;</p>

        <h4 style={{ textAlign: "left" }}>20. Consent Form Signature Page</h4>

        <div style={{ textAlign: "left" }}>
          <p>
            I have reviewed all the information in this consent form related to
            the study called:
          </p>
          <p style={{ textAlign: "center" }}>
            <i>
              Alteplase Compared to Tenecteplase in Patients with Acute Ischemic
              Stroke: <br/>QuICR and OPTIMISE Registry based Pragmatic Randomized
              Controlled Trial (ACT RRCT)
            </i>
          </p>

          <p>The administration of either Alteplase or Tenecteplase cannot be undone. You are now being asked to consent to
            data
            collection. If you decide not to consent, you will not be contacted in the future. You may also withdraw consent
            for
            further contact but continue follow-up via health record linkage. Serious adverse drug reactions and serious
            adverse
            events related to studies must be reported to authorities, whether or not you consent.</p>

          <p>
            I have been given the opportunity to discuss this study. All of my
            questions have been answered to my satisfaction.{" "}
          </p>
          <p>
            I authorize access to my personal health information, and research
            study data as explained in this form.
          </p>
          <p>
            This signature on this consent form means that I agree to stay in
            this study. I understand that I am free to withdraw at any time
            without affecting my future care.
          </p>

          {showForEmail && (
            <Form.Item className="decision-box">
              <label>
                <div className="form-label">
                  Please check the appropriate box to indicate your decision:
                </div>
                {props.form.getFieldDecorator("sb_dic_consent_option", {
                  rules: [
                    {
                      required: true,
                      message: "Required",
                    },
                  ],
                })(
                  <Radio.Group>
                    <Radio value="withdraw_from_study">
                      I do not wish to participate in this study. Do not use any of my data.
                    </Radio>
                    <br />
                    <Radio value="withdraw_from_study_allow_data_collection_via_linkage">
                      I wish to withdraw from the study,
                      but my data collected up to date may be used. I do not wish to be contacted in the
                      future or have any more of my data collected.
                    </Radio>
                    <br />
                    <Radio value="stay_in_study_no_contact">
                      I wish to participate in the study. My health data may be used, but I do not wish to be contacted in the future.
                    </Radio>
                    <br />
                    <Radio value="stay_in_study">
                      I wish to participate in this study. My health data can be used, and you may contact me to answer the questionnaire in the future.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          )}
          <p>
            E-messaging (email and texting) can be used by a member or members of the research team to communicate with you
            while
            you are in this study. All local communication done with you will be done only through a Health PEI Webmail
            account,
            or by a phone issued to a research member through Health PEI. You will also receive e-messages from the research
            team in Calgary. All efforts are made to keep information sent or received private, but it is possible other
            people
            may be able to see, read, and change messages sent to or from Health PEI or Calgary.
          </p>

          {showForEmail && (
            <Form.Item>
              <label>
                {props.form.getFieldDecorator(
                  "wp_participant_agree_being_contacted",
                  {
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  }
                )(
                  <Radio.Group>
                    <Radio value="true">
                      I give my permission to be contacted by a member or members of the research
                      team from aHealth PEI Webmail account or aHealth PEI cell phone by research
                      staffas well as the research staff in Calgary to communicate during this study
                    </Radio>
                    <br />
                    <Radio value="false">
                      I do not wish to be contacted by email or text message,
                      unless I otherwise give permission at another time during this study
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          )}
          {showForEmail &&
            props.form.getFieldValue("wp_participant_agree_being_contacted") ===
              "true" && (
              <Form.Item className="no-bottom-margin">
                <label>
                  <div
                    className="form-label"
                    style={{ display: "inline-block", width: "150px" }}
                  >
                    Email
                  </div>
                  {props.form.getFieldDecorator("pei_contact_by_email", {
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  })(
                    <Radio.Group>
                      <Radio value="true">Yes</Radio>
                      <Radio value="false">No</Radio>
                    </Radio.Group>
                  )}
                </label>
              </Form.Item>
            )}

          {showForEmail &&
            props.form.getFieldValue("wp_participant_agree_being_contacted") ===
              "true" && (
              <Form.Item>
                <label>
                  <div
                    className="form-label"
                    style={{ display: "inline-block", width: "150px" }}
                  >
                    Text message
                  </div>
                  {props.form.getFieldDecorator("pei_contact_by_message", {
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  })(
                    <Radio.Group>
                      <Radio value="true">Yes</Radio>
                      <Radio value="false">No</Radio>
                    </Radio.Group>
                  )}
                </label>
              </Form.Item>
            )}

          {showForEmail &&
            props.form.getFieldValue(
              "wp_participant_agree_being_contacted"
            ) && (
              <div>
                <SignatureTrimmed
                  fieldName="initials_signature"
                  label="Initials"
                  form={props.form}
                />
              </div>
            )}

          {isPatient && <Form.Item>
            <label>
              <div className="form-label">Participant Name</div>
              {props.form.getFieldDecorator("mtl_consent_participant_name", {
                initialValue: props.mtl_consent_participant_name,
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
              })(
                <Input
                  prefix={<Icon type="user" style={{ color: "#eee" }} />}
                  placeholder="Participant Name"
                />
              )}
            </label>
          </Form.Item>}

          {isEmail && isSurrogate && (
            <Form.Item>
              <label>
                <div className="form-label">Substitute Decision Maker</div>
                {props.form.getFieldDecorator("mtl_consent_participant_email", {
                  initialValue: props.mtl_consent_participant_email,
                  rules: [
                    {
                      required: true,
                      message: "Please enter the Substitute Decision Maker's email",
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder="Substitute Decision Maker Email"
                  />
                )}
              </label>
            </Form.Item>
          )}
          {isEmail && isPatient && (
            <Form.Item>
              <label>
                <div className="form-label">Participant Email</div>
                {props.form.getFieldDecorator("mtl_consent_participant_email", {
                  initialValue: props.mtl_consent_participant_email,
                  rules: [
                    {
                      required: true,
                      message: "Please enter the participant's email",
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder="Participant Email"
                  />
                )}
              </label>
            </Form.Item>
          )}

          {isPatient && showForEmail && (
            <div>
              <Signature
                fieldName="mtl_consent_participant_signature"
                label="Signature of Participant"
                form={props.form}
              />
            </div>
          )}

          <div>
            <Form.Item>
              <label>
                <div className="form-label">
                  Person Conducting the Consent Discussion Name
                </div>
                {props.form.getFieldDecorator(
                  "mtl_consent_investigator_name_1",
                  {
                    initialValue: props.mtl_consent_investigator_name_1,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  }
                )(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{ color: "#eee" }} />}
                    placeholder="Name (Printed)"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && (
              <Signature
                fieldName="mtl_consent_investigator_signature_1"
                label="Signature of Person Conducting the Consent Discussion"
                form={props.form}
              />
            )}
          </div>

          <div>
            <Form.Item>
              <label>
                <div className="form-label">Principal Investigator Name</div>
                {props.form.getFieldDecorator(
                  "mtl_consent_investigator_name_2",
                  {
                    initialValue: props.mtl_consent_investigator_name_2,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  }
                )(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{ color: "#eee" }} />}
                    placeholder="Name (Printed)"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && (
              <Signature
                fieldName="mtl_consent_investigator_signature_2"
                label="Signature of Principal Investigator"
                form={props.form}
              />
            )}
          </div>

          {isSurrogate && (
            <div>
              <Form.Item>
                <label>
                  <div className="form-label">
                    Substitute Decision Maker Name
                  </div>
                  {props.form.getFieldDecorator(
                    "mtl_consent_representative_name",
                    {
                      initialValue: props.mtl_consent_representative_name,
                      rules: [
                        {
                          required: true,
                          message: "Required",
                        },
                      ],
                    }
                  )(
                    <Input
                      prefix={<Icon type="user" style={{ color: "#eee" }} />}
                      placeholder="Name (Printed)"
                    />
                  )}
                </label>
              </Form.Item>

              {showForEmail && (
                <Signature
                  fieldName="mtl_consent_representative_signature"
                  label="Signature of Participant's Substitute Decision Maker"
                  form={props.form}
                />
              )}
            </div>
          )}

          {!isEmail && (
            <div>
              <Form.Item>
                <label>
                  <div className="form-label">Impartial Witness Name</div>
                  {props.form.getFieldDecorator("mtl_consent_witness_name", {
                    initialValue: props.mtl_consent_witness_name,
                  })(
                    <Input
                      prefix={<Icon type="user" style={{ color: "#eee" }} />}
                      placeholder="Impartial Witness Name"
                    />
                  )}
                </label>
              </Form.Item>

              <Signature
                fieldName="mtl_consent_witness_signature"
                label="Signature of Impartial Witness"
                form={props.form}
                optional
              />

              <p>
                If the consent discussion has been conducted in a language other
                than English, please indicate:
              </p>

              {!isEmail && (
                <Form.Item>
                  <label>
                    <div className="form-label">Language</div>
                    {props.form.getFieldDecorator(
                      "sb_dic_interpreter_language",
                      {
                        initialValue: props.sb_dic_interpreter_language,
                      }
                    )(<Input placeholder="Language" />)}
                  </label>
                </Form.Item>
              )}

              <Form.Item>
                <label>
                  <div className="form-label">Translator Name</div>
                  {props.form.getFieldDecorator("sb_dic_interpreter_name", {
                    initialValue: props.sb_dic_interpreter_name,
                    rules: [
                      {
                        required: hasLanguage,
                        message: "Required",
                      },
                    ],
                  })(
                    <Input
                      prefix={<Icon type="user" style={{ color: "#eee" }} />}
                      placeholder="Translator Name (Printed)"
                    />
                  )}
                </label>
              </Form.Item>

              <Signature
                fieldName="sb_dic_interpreter_signature"
                label="Signature of Translator"
                form={props.form}
                optional={!hasLanguage}
              />
            </div>
          )}
          <Form.Item>
            <label>
              <div className="form-label">
                Do you consent to the terms described above?
              </div>
              {props.form.getFieldDecorator("consent_provided", {
                initialValue: props.consent_provided,
                rules: [
                  {
                    required: true,
                    message: "Do you consent to the terms described above?",
                  },
                ],
              })(
                <Select>
                  <Option value="yes">Yes</Option>
                  <Option value="">No</Option>
                </Select>
              )}
            </label>
          </Form.Item>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypePei/Step3aPatient.js